require('./common/lib/logs')

require('./browser/main')
